import React from 'react';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, onValue } from "firebase/database";
import LogoA from '../../Logo/medical.png';
import base64 from 'base-64';
import { database } from '../../App';

const Home = () => {
  const [connected, setConnected] = React.useState(false);
  const [emailInput, setEmailInput] = React.useState(false);
  const [user, setUser] = React.useState(false);
  const [senhaInput, setSenha] = React.useState(false);
  const [state, setState] = React.useState({
    open: false,
    vertical: 'right',
    horizontal: 'center',
  });

  const { vertical, horizontal, open } = state;
  const navigate = useNavigate();

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  React.useEffect(() => {
    const db = getDatabase();
    const auth = getAuth();

    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
        const dbRef = ref(db, `${base64.encode(user.email)}/isconnected`);

        onValue(dbRef, (snapshot) => {
          const data = snapshot.val();
          setConnected(data);
        });
      }
    });
  }, []);

  const goMeansure = () => {
    if (!emailInput || !senhaInput) {
      window.alert('Insira os campos de usuário e senha');
    } else {
      const dbRef = ref(database, `${base64.encode(emailInput)}/isconnected`);

      onValue(dbRef, (snapshot) => {
        const auth = getAuth();

        signInWithEmailAndPassword(auth, emailInput, senhaInput)
          .then(() => {})
          .catch(() => {
            window.alert('Verifique Usuário e senha');
          });
      });
    }
  };

  if (user) {
    navigate('/measure');
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: window.innerWidth >= 1024 ? 'row' : 'column',
        backgroundColor: '#f3f4f6',
      }}
    >
      {/* Lado esquerdo */}
      <div
        style={{
          width: window.innerWidth >= 1024 ? '50%' : '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '450px',
            backgroundColor: 'white',
            borderRadius: '24px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
            padding: '32px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              marginBottom: '24px',
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/medical.png`}
              alt="Logo"
              style={{
                width: '96px',
                height: '96px',
                objectFit: 'contain',
                marginBottom: '16px',
              }}
            />

            <h1
              style={{
                fontSize: '24px',
                fontWeight: 'bold',
                textAlign: 'center',
                color: '#1f2937',
              }}
            >
              Sistema de Atendimento e Agendamento
            </h1>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <input
              type="email"
              placeholder="seu@email.com"
              onChange={(e) => setEmailInput(e.target.value)}
              style={{
                width: '100%',
                border: '1px solid #d1d5db',
                borderRadius: '12px',
                padding: '14px 16px',
                outline: 'none',
                fontSize: '16px',
              }}
            />

            <input
              type="password"
              placeholder="••••••••"
              onChange={(e) => setSenha(e.target.value)}
              style={{
                width: '100%',
                border: '1px solid #d1d5db',
                borderRadius: '12px',
                padding: '14px 16px',
                outline: 'none',
                fontSize: '16px',
              }}
            />

            <button
              onClick={goMeansure}
              style={{
                width: '100%',
                backgroundColor: '#2563eb',
                color: 'white',
                fontWeight: '600',
                padding: '14px',
                borderRadius: '12px',
                border: 'none',
                cursor: 'pointer',
                boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
                transition: '0.2s',
              }}
            >
              Entrar
            </button>
          </div>

          <div
            style={{
              marginTop: '24px',
              display: 'flex',
              gap: '8px',
              fontSize: '14px',
            }}
          >
            <span style={{ color: '#4b5563' }}>
              Ainda não tem uma conta?
            </span>

            <button
              onClick={() => navigate('/registro')}
              style={{
                color: '#2563eb',
                fontWeight: 'bold',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              Clique Aqui
            </button>
          </div>

          <div
            style={{
              marginTop: '12px',
              display: 'flex',
              gap: '8px',
              fontSize: '14px',
            }}
          >
            <span style={{ color: '#4b5563' }}>
              Esqueceu sua senha?
            </span>

            <button
              onClick={() => navigate('/password')}
              style={{
                color: '#2563eb',
                fontWeight: 'bold',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              Clique Aqui
            </button>
          </div>
        </div>
      </div>

      {/* Lado direito */}
      {window.innerWidth >= 1024 && (
        <div
          style={{
            width: '50%',
            height: '100vh',
          }}
        >
          <img
            src={'/medical.png'}
            alt="Background"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </div>
      )}

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        message="Erro ao efetuar Login"
        key={vertical + horizontal}
      />
    </div>
  );
};

export default Home;